import type { TableProps } from "antd";
import { Col, Row, Table, Typography } from "antd";
import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { formatDate } from "../../../helpers/date";
import useMultiNotification from "../../../hooks/useNotification";
import CopyIcon from "./../../../assets/svgs/CopyIcon.svg";
import "./index.css";

const RedeemedVouchersTable: React.FC<RedeemedDiscountVouchersTableProp> = ({
  vouchers,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const columns: TableProps<RedeemedDiscountVouchersProp>["columns"] = [
    {
      title: "Voucher Number",
      render: (row) => (
        <Typography
          style={{ display: "flex", alignContent: "center", gap: "10px" }}
        >
          {row.voucherNumber}
          <CopyToClipboard
            text={row.voucherNumber || ""}
            onCopy={() => {
              openNotification(
                "success",
                "Success",
                `Voucher ${row.voucherNumber} Copied to Clipboard`
              );
            }}
          >
            <img
              onClick={(e) => {
                e.preventDefault();
              }}
              src={CopyIcon}
              className="cursor-pointer "
            />
          </CopyToClipboard>
        </Typography>
      ),
    },
    {
      title: "Amount",
      dataIndex: "discountAmount",
      key: "discountAmount",
    },
    {
      title: "Type",
      dataIndex: "voucherType",
      key: "voucherType",
      render: (text) => (
        <span>{text === "ONCE" ? "One Time" : "Every Month"}</span>
      ),
    },
    {
      title: "Created",
      dataIndex: "dateCreated",
      key: "dateCreated",
      render: (text) => <span>{formatDate(new Date(text))}</span>,
    },
    {
      title: "Customer",
      render: (row) => (
        <span>{`${
          row.connectionType === "INTERNET"
            ? row.username
            : row.cFirstName + " " + row.cLastName
        }`}</span>
      ),
    },
    {
      title: "Used By",
      render: (row) => (
        <span>{`${row.firstName} ${row.lastName} (${row.headType})`}</span>
      ),
    },
    {
      title: "Used On",
      dataIndex: "dateRedeemed",
      key: "dateRedeemed",
      render: (text) => (
        <span className="voucher-redeemed-date">
          {formatDate(new Date(text))}
        </span>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <div className="netwala-users-table-container">
        <Row>
          <Col span={24}>
            <Typography className="netwala-user-tables-heading">
              Used Vouchers
            </Typography>
            <Table
              className="netwala-users-table striped-table"
              columns={columns}
              dataSource={vouchers}
              pagination={false}
              scroll={{ x: "max-content" }}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};
export default RedeemedVouchersTable;
